import {
  Card,
  CardBody,
  Form,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
  Button,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import { useState, React, useEffect, useRef, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;
import subscribersTemplate from "../../../data/template/subscribers_template.xlsx";
import { MainContext } from "context/MainContext.js";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const SubscriberImport = () => {
  const history = useHistory();
  const location = useLocation();
  let formError = false;

  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [file, setFile] = useState();
  const [uploadBtnEnabled, setUploadBtnEnabled] = useState(false);

  const inputFileRef = useRef(null);
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.subscribers.create"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }

    fetchData();
  }, []);

  const fetchData = () => {
    fetch("/api/v1/subscriber/import", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {})
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleUpload = () => {
    setShowLoading(true);

    const uploadFile = inputFileRef.current.files[0];

    const formData = new FormData();
    formData.append("file", uploadFile);

    fetch("/api/v1/subscriber/import", {
      method: "POST",
      headers: {
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        setFile();
        inputFileRef.current.value = null;
        setUploadBtnEnabled(false);

        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while importing subscribers", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          toast.success("Subscribers created successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((error) => {
        toast.error("A problem occured while importing the subscribers", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          theme: "colored",
        });
        setShowLoading(false);
        setFile([]);
        inputFileRef.current.value = null;
        setUploadBtnEnabled(false);
        console.log(error.message);
      });
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = subscribersTemplate;
    link.target = "_blank";
    link.setAttribute("download", "subscribers_template.xlsx");
    document.body.appendChild(link);
    link.click();
  };

  const handleFileChange = (event) => {
    const selectedFile = Array.from(event.target.files);

    if (selectedFile == undefined || selectedFile.length == 0) {
      setUploadBtnEnabled(false);
    } else {
      setUploadBtnEnabled(true);
    }

    setFile(selectedFile);
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/subscribers/list",
                      }}
                    >
                      Subscribers
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Import</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Row>
              <Col>
                {errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Subscriber Template</CardTitle>
                  </CardHeader>

                  <CardBody>
                    <Row>
                      <Col>
                        Download the Excel template to fill in for importing
                        subscribers
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Button
                          className="btn-round"
                          color="info"
                          onClick={handleDownload}
                        >
                          Download
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Subscriber Import</CardTitle>
                  </CardHeader>

                  <CardBody>
                    <Row>
                      <Col>
                        Upload the template file filled from the template
                        downloaded in the left-hand section
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "25px", marginBottom: "25px" }}>
                      <Col>
                        <div>
                          <input
                            type="file"
                            onChange={handleFileChange}
                            ref={inputFileRef}
                            accept=".xlsx, .xls"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div>
                          <button
                            onClick={handleUpload}
                            disabled={!uploadBtnEnabled}
                          >
                            Upload
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SubscriberImport;
